module.exports = __webpack_public_path__ + "img/home_business_item1.2f26d864.jpg";